import { features, stats } from '@/mocks/home';

export default function FeatureSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            为什么选择蜜桃视频？
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大核心优势，为你打造极致的视频观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all hover:bg-background-50"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-5">
              <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}